import PageTabs from "./PageTabs";

const ROUND_NAME_MAP = {
  Qualifying: "Vòng loại",
  "Round 1": "Vòng 1",
  "Round 2": "Vòng 2",
  "Qual. Final": "Chung kết vòng loại",
  "Round 3": "Vòng 3",
  Playoffs: "Vòng play-off",
  Group: "Vòng bảng",
  "1/8 Final": "Vòng 1/8",
  Quarterfinals: "Tứ kết",
  Semifinals: "Bán kết",
  finals: "Chung kết",
  "League Round": "Vòng đấu giải",
};

const GROUP_COLORS = [
  { text: "#454444", bg: "#DBE8F1" },
  { text: "#fff", bg: "#E4010B" },
  { text: "#fff", bg: "#004EA0" },
  { text: "#fff", bg: "#00A85D" },
  { text: "#454444", bg: "#FFD600" },
  { text: "#fff", bg: "#2B2C36" },
  { text: "#fff", bg: "#FF6600" },
  { text: "#fff", bg: "#EE34A3" },
  { text: "#fff", bg: "#FFD700" },
  { text: "#fff", bg: "#00A85D" },
];

const RANK_FALLBACK =
  "bg-[var(--bxh-badge-bg)] kbv-bxh-badge";

function getRankStyle(rank, isWorldCup) {
  const n = Number(rank);
  if (Number.isNaN(n) || n <= 0) return RANK_FALLBACK;
  if (isWorldCup) {
    if (n <= 2) return "bg-[#2eb876] kbv-bxh-c-on-dark";
    if (n === 3) return "bg-[#d71a1e] kbv-bxh-c-on-dark";
    return RANK_FALLBACK;
  }
  if (n <= 8) return "bg-[#2eb876] kbv-bxh-c-on-dark";
  if (n <= 24) return "bg-[#d71a1e] kbv-bxh-c-on-dark";
  return RANK_FALLBACK;
}

function CupGroupTable({ groupName, scoreItems, groupIndex, isWorldCup }) {
  if (!Array.isArray(scoreItems) || scoreItems.length === 0) return null;
  const sorted = [...scoreItems].sort((a, b) => Number(a.rank) - Number(b.rank));
  const groupLabel = groupName?.split(" ")[1] || groupName || "";
  const colors = GROUP_COLORS[groupIndex % GROUP_COLORS.length];

  return (
    <div className="space-y-2 mt-1">
      {isWorldCup && (
        <div className="flex items-center gap-2 px-2 lg:px-0">
          <span
            className="flex px-2 py-1 items-center justify-center rounded text-sm font-semibold"
            style={{ color: colors.text, backgroundColor: colors.bg }}
          >
            Bảng {groupLabel}
          </span>
        </div>
      )}
      <div className="bg-[var(--background-header)] md:rounded border border-[var(--bxh-border)] md:overflow-hidden">
        <div className="relative flex overflow-hidden">
          <div className="pointer-events-none absolute top-0 bottom-0 left-[198px] w-2 z-30 bg-gradient-to-r from-black/10 to-transparent md:hidden" />

          <div className="flex-none md:flex-1 z-10">
            <table className="text-[13px] table-fixed md:w-full">
              <colgroup>
                <col style={{ width: 48 }} />
                <col className="w-[150px] md:w-auto" />
              </colgroup>
              <thead className="bg-[var(--surface-row-alt2)]">
                <tr className="h-[37px]">
                  <th className="pl-3 pr-3 text-left kbv-bxh-fg font-semibold text-xs align-middle">
                    #
                  </th>
                  <th className="pl-0 pr-2 text-left kbv-bxh-fg font-semibold text-xs align-middle">
                    Đội bóng
                  </th>
                </tr>
              </thead>
              <tbody className="kbv-bxh-fg">
                {sorted.map((row) => {
                  const team = row.teams;
                  return (
                    <tr
                      key={row.id}
                      className="h-[40px] border-t border-[var(--bxh-border)] hover:bg-[var(--bxh-row-hover)] transition-colors"
                    >
                      <td className="pl-3 pr-3 align-middle w-[48px] bg-[var(--background-header)]">
                        <span
                          className={`inline-flex w-6 h-6 items-center justify-center rounded text-[10px] lg:text-xs font-bold shrink-0 ${getRankStyle(
                            row.rank,
                            isWorldCup,
                          )}`}
                        >
                          {row.rank}
                        </span>
                      </td>
                      <td className="pl-0 pr-2 align-middle max-w-[150px] bg-[var(--background-header)]">
                        <div className="flex items-center gap-1.5 min-w-0">
                          {team?.logo && (
                            <div className="w-5 h-5 flex items-center justify-center shrink-0 overflow-hidden">
                              <img
                                src={team.logo}
                                alt={team?.name || ""}
                                width={20}
                                height={20}
                                className="w-5 h-5 object-contain"
                              />
                            </div>
                          )}
                          <span
                            title={team?.nameVi || team?.name}
                            className="block truncate text-xs lg:text-sm min-w-0 flex-1 kbv-bxh-fg"
                          >
                            {team?.nameVi || team?.name || "-"}
                          </span>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          <div className="flex-1 overflow-x-auto overscroll-x-contain md:flex-none md:overflow-x-visible league-standing-scrollbar-hide">
            <table className="text-[13px] table-auto w-full md:w-auto">
              <thead className="bg-[var(--surface-row-alt2)]">
                <tr className="h-[37px]">
                  <th className="px-2 lg:px-4 text-center kbv-bxh-fg font-semibold text-xs whitespace-nowrap align-middle">
                    Trận
                  </th>
                  <th className="px-2 lg:px-4 text-center kbv-bxh-fg font-semibold text-xs whitespace-nowrap align-middle">
                    Điểm
                  </th>
                  <th className="px-2 lg:px-4 text-center font-semibold text-xs whitespace-nowrap kbv-bxh-c-win align-middle">
                    T
                  </th>
                  <th className="px-2 lg:px-4 text-center font-semibold text-xs whitespace-nowrap kbv-bxh-c-draw align-middle">
                    H
                  </th>
                  <th className="px-2 lg:px-4 text-center font-semibold text-xs whitespace-nowrap kbv-bxh-c-lose align-middle">
                    B
                  </th>
                  <th className="px-2 lg:px-4 text-center whitespace-nowrap kbv-bxh-fg font-semibold text-xs align-middle">
                    BT/BB
                  </th>
                  <th className="px-2 lg:px-4 pr-3 lg:pr-5 text-center kbv-bxh-fg font-semibold text-xs whitespace-nowrap align-middle">
                    +/-
                  </th>
                </tr>
              </thead>
              <tbody className="kbv-bxh-fg">
                {sorted.map((row) => {
                  const gd = Number(row.goalDifference);
                  const gdStr = gd > 0 ? `+${gd}` : String(gd);
                  return (
                    <tr
                      key={row.id}
                      className="h-[40px] border-t border-[var(--bxh-border)] hover:bg-[var(--bxh-row-hover)] transition-colors"
                    >
                      <td className="px-2 lg:px-4 text-center whitespace-nowrap text-[13px] align-middle">
                        {row.totalCount}
                      </td>
                      <td className="px-2 lg:px-4 text-center whitespace-nowrap font-bold text-[13px] align-middle">
                        {row.integral}
                      </td>
                      <td className="px-2 lg:px-4 text-center whitespace-nowrap text-[13px] align-middle">
                        <span className="kbv-bxh-c-win">{row.winCount}</span>
                      </td>
                      <td className="px-2 lg:px-4 text-center whitespace-nowrap text-[13px] align-middle">
                        <span className="kbv-bxh-c-draw">{row.drawCount}</span>
                      </td>
                      <td className="px-2 lg:px-4 text-center whitespace-nowrap text-[13px] align-middle">
                        <span className="kbv-bxh-c-lose">{row.loseCount}</span>
                      </td>
                      <td className="px-2 lg:px-4 text-center whitespace-nowrap text-[13px] align-middle">
                        {row.getScore}/{row.loseScore}
                      </td>
                      <td className="px-2 lg:px-4 pr-3 lg:pr-5 text-center whitespace-nowrap text-[13px] align-middle">
                        {gdStr}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function LeagueStandingCup({
  roundScoreItems,
  isWorldCup = false,
}) {
  if (!Array.isArray(roundScoreItems) || roundScoreItems.length === 0) return null;

  const groupRounds = roundScoreItems.filter((round) =>
    String(round.roundName ?? "")
      .toLowerCase()
      .startsWith("group"),
  );
  const otherRounds = roundScoreItems.filter(
    (round) =>
      !String(round.roundName ?? "")
        .toLowerCase()
        .startsWith("group"),
  );

  if (isWorldCup) {
    const tabs = otherRounds.map((round) => ({
      id: String(round.id),
      label: ROUND_NAME_MAP[round.roundName] || round.roundName,
      content: (
        <div className="space-y-3 lg:space-y-6">
          {(round.groupScoreItems || []).map((group, idx) => (
            <CupGroupTable
              key={group.id}
              groupName={group.groupName}
              scoreItems={group.scoreItems}
              groupIndex={idx}
              isWorldCup
            />
          ))}
        </div>
      ),
    }));

    return (
      <div className="space-y-3 lg:space-y-6">
        {groupRounds.map((round) =>
          (round.groupScoreItems || []).map((group, idx) => (
            <CupGroupTable
              key={group.id}
              groupName={group.groupName}
              scoreItems={group.scoreItems}
              groupIndex={idx}
              isWorldCup
            />
          )),
        )}
        {tabs.length > 0 && (
          <PageTabs tabs={tabs} defaultTab={tabs[0]?.id} />
        )}
      </div>
    );
  }

  const tabs = roundScoreItems.map((round) => ({
    id: String(round.id),
    label: ROUND_NAME_MAP[round.roundName] || round.roundName,
    content: (
      <div className="space-y-6">
        {(round.groupScoreItems || []).map((group, idx) => (
          <CupGroupTable
            key={group.id}
            groupName={group.groupName}
            scoreItems={group.scoreItems}
            groupIndex={idx}
            isWorldCup={false}
          />
        ))}
      </div>
    ),
  }));

  return <PageTabs tabs={tabs} defaultTab={tabs[0]?.id} />;
}
